<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-form-item label="所属组织机构" style="margin-right:15px">
        <el-input v-model="form.partyGroupCode" :disabled="true" />
      </el-form-item>
      <el-form-item label="部门名称" style="margin-right:15px">
        <el-input v-model="form.name" :disabled="true" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'DepartmentDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        partyGroupCode: '',
        name: ''
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/department/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
